//import navItems from "lib/nav-items";
//import navItemsV2 from "lib/nav-items-v2";
//import NavigationCards from "../../../navigation/navigation-cards/navigation-cards";
import { useContext, useMemo } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { getNavigationCardItems } from "lib/utils";
import NavigationCards from "components/navigation/navigation-cards/navigation-cards";
import NavigationCards2 from "components/navigation/navigation-cards/navigation-cards2";


export default function GuestUsersReportsIndex() {

  const location = useLocation();

  return (
    <NavigationCards2 route={location.pathname} />
  );
}
